import useTranslation from "../../common/translations";
import ResultItem from "./ResultItem";
import ResultSection from "./ResultSection";
import React from "react";
export default function ResultsSections({ groups, onSelect, isTypoFallback = false, }) {
    const { t } = useTranslation("site-search");
    const visibleGroups = groups.filter((g) => g.items.length > 0);
    if (!visibleGroups.length)
        return null;
    function sectionTitle(groupTitle, index) {
        if (isTypoFallback && index === 0) {
            return t("search.typo_section_title");
        }
        if (groupTitle === "Suggestions") {
            return t("search.suggestions_group_title");
        }
        return groupTitle;
    }
    return (<div className="space-y-8">
      {visibleGroups.map((group, index) => (<div key={group.title}>
          <ResultSection title={sectionTitle(group.title, index)}/>
          <div className="mt-4 space-y-4">
            {group.items.map((item) => (<ResultItem key={`${item.type}:${item.url}`} item={item} onSelect={onSelect}/>))}
          </div>
        </div>))}
    </div>);
}
